import React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { FormControl } from '@mui/material';
import { isBefore, isAfter, isValid, parse } from "date-fns";
import { createTheme, ThemeProvider } from '@mui/material/styles';

import style from './index.module.scss'

const CommonDateField = ({ onChange, value, InputProps, onOpen, onClose, open, renderInput, minDate, maxDate, label, required, className }) => {
    const contractStatus = sessionStorage.getItem('Selected Contract Status');
    const warningCheck = (value === '');
    const inputDateFormats = ["MM/dd/yyyy", "M/d/yyyy", "MM-dd-yyyy", "M-d-yyyy", "yyyy-MM-dd", "MMM dd, yyyy", "MMM d, yyyy", "MMMM dd, yyyy", "MMMM d, yyyy"];

    const getDefaultCalendarMonth = (minDate, maxDate) => {
        const today = new Date();

        if (minDate && isBefore(today, minDate)) {
            return minDate;
        }

        if (maxDate && isAfter(today, maxDate)) {
            return maxDate;
        }

        return today;
    };

    const theme = createTheme({
        palette: {
            error: {
                main: '#cc0000', // Customize your error color here
            },
            warning: {
                main: '#f57c00', // Customize your error color here
            },
        },
    });

    const parseTypedDate = (typedValue) => {
        if (!typedValue || typeof typedValue !== "string") return null;
        const trimmedInput = typedValue.trim();
        if (!trimmedInput) return null;
        const hasFourDigitYear = /\b\d{4}\b/.test(trimmedInput);
        if (!hasFourDigitYear) return null;

        for (const formatPattern of inputDateFormats) {
            const parsedDate = parse(trimmedInput, formatPattern, new Date());
            if (isValid(parsedDate) && parsedDate.getFullYear() >= 1000) {
                return parsedDate;
            }
        }

        return null;
    };

    const handleDateChange = (newValue, keyboardInputValue) => {
        if (keyboardInputValue) {
            const parsedTypedDate = parseTypedDate(keyboardInputValue);
            if (parsedTypedDate) {
                onChange(parsedTypedDate);
                return;
            }

            // Keep previous value for partial/invalid typed input
            onChange(value || null);
            return;
        }

        onChange(newValue);
    };
    return (

        <div>
            <div className={`${style.lableStyle}`}>{label}{required && '*'}</div>
            <div className={`${className} ${style.marginTop}`}>
                <LocalizationProvider dateAdapter={AdapterDateFns} sx={className}>
                    <ThemeProvider theme={theme}>
                        <FormControl size="small" className={style.fullWidth}
                        // sx={`${{
                        //     '& .MuiFormControlLabel-root': {
                        //         color: warningCheck ? !required ? theme.palette.error.main : theme.palette.warning.main : '',
                        //     },
                        // }}`}
                        // error={warningCheck}
                        >
                            <DesktopDatePicker
                                inputFormat="MMM dd, yyyy"
                                // mask="___ __, ____"
                                value={value}
                                onChange={handleDateChange}
                                InputProps={InputProps}
                                minDate={minDate}
                                maxDate={maxDate}
                                renderInput={renderInput}
                                reduceAnimations={true}
                                defaultCalendarMonth={getDefaultCalendarMonth(minDate, maxDate)}
                                readOnly={contractStatus === "ACTIVE" ? true : false}
                            />
                        </FormControl>
                    </ThemeProvider>
                    {/* <div>
                        {warningCheck ? (<div className={`${style.helperText} ${required ? style.errorColor : style.warningColor}`}>Could not find data</div>) : ''}
                    </div> */}
                </LocalizationProvider>
            </div>
        </div>
    )
}

export default CommonDateField;